import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import { store } from './store'
import promiseFinally from 'promise.prototype.finally'
import sensors from 'sa-sdk-javascript'
import 'normalize.css'
import 'animate.css'
import './styles/app.scss'
import './addVant'
import ba from 'vue-ba'
import { Rate, Popup, RadioGroup, Radio, Lazyload } from 'vant'
import VueSmsCode from 'vue-sms-check-code'
import Bridge from '@/util/JSbridge.js'
Vue.prototype.$bridge = Bridge
const baiduTjId =
  process.env.VUE_CLI_BUILD_TARGET === 'prod'
    ? 'b05e3b1d5d6ee72cedb2dd25e51389fc'
    : 'b05e3b1d5d6ee72cedb2dd25e51389fc'
// 判断是不是小程序
const isMini = /miniProgram/i.test(navigator.userAgent.toLowerCase())
Vue.prototype.$isMini = isMini

Vue.use(Rate, Popup, Radio)
Vue.use(RadioGroup)
Vue.use(Lazyload)
Vue.prototype.$sensors = sensors
Vue.use(ba, baiduTjId)
Vue.use(VueSmsCode)
promiseFinally.shim()
Vue.config.productionTip = process.env.NODE_ENV === 'production'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
